import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import { useStoreActions } from 'easy-peasy';

import useCustomGetStoreState from "../../hooks/useCustomGetStoreState.jsx";

import VideosPageContentTest from "./VideosPageContentTest.jsx";
import AuthorizationChecker from "../../services/AuthorizationChecker.js";

const VideosPageTest = () => {

    const { allVideos, isFetchingAllVideos, isGradualFetchingAllVideos } = useCustomGetStoreState("videos");
    const { fetchAllPropsForAllVideos } = useStoreActions(actions => actions.videos);

    const [fetchPropsDone, setFetchPropsDone] = useState(false);

    useEffect(() => {
        if (!allVideos || allVideos.length === 0 || fetchPropsDone) return;
        AuthorizationChecker.hasGetPropsForAllRights('videos') && fetchAllPropsForAllVideos();
        setFetchPropsDone(true);
    }, [allVideos]);

    return <Container fluid>
        <Row>
            <Col>
                <h2>Test recherche "profonde" de vidéos</h2>
                <p>Cette page permet de tester la recherche de vidéos en back sur des informations "profondes" : appellations métiers en particulier.</p>
            </Col>
        </Row>
        <VideosPageContentTest videos={allVideos} isVideosLoading={isFetchingAllVideos || isGradualFetchingAllVideos} displayCreationBtn={true} />
        </Container>;
};

export default VideosPageTest;